// extracted by mini-css-extract-plugin
export default {"Label":"Z8ZYpVdm","White":"Q0SzJdtE"};